import {gsap} from "gsap";

export default {
    methods: {
        enterGsap() {
            console.log('enterGsap')
            return gsap.from(this.$refs[this.stepName],
                {
                    opacity: 0,
                    x: 50,
                    duration: this.step._enter_animate_duration,
                });

        },
        leaveGsap() {
            return gsap.to(this.$refs[this.stepName],
                {
                    opacity: 0,
                    x: -50,
                    duration: this.step._leave_animate_duration,
                });
        },
        backEnterGsap() {
            return gsap.from(this.$refs[this.stepName],
                {
                    opacity: 0,
                    x: -50,
                    duration: this.step._leave_animate_duration,
                });
        },
        backLeaveGsap() {
            console.log('backEnterGsap')
            return gsap.to(this.$refs[this.stepName],
                {
                    opacity: 0,
                    x: 50,
                    duration: this.step._enter_animate_duration,
                });
        },
    },
}
